/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRemoteSessionIssuerForm,
  CreateRemoteSessionIssuerForm$Outbound,
  CreateRemoteSessionIssuerForm$outboundSchema,
} from "../components/createremotesessionissuerform.js";

export type CreateGlobalRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateGlobalRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createRemoteSessionIssuerForm: CreateRemoteSessionIssuerForm;
};

/** @internal */
export type CreateGlobalRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateGlobalRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    CreateGlobalRemoteSessionIssuerSecurity$Outbound,
    CreateGlobalRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createGlobalRemoteSessionIssuerSecurityToJSON(
  createGlobalRemoteSessionIssuerSecurity:
    CreateGlobalRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    CreateGlobalRemoteSessionIssuerSecurity$outboundSchema.parse(
      createGlobalRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type CreateGlobalRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateRemoteSessionIssuerForm: CreateRemoteSessionIssuerForm$Outbound;
};

/** @internal */
export const CreateGlobalRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    CreateGlobalRemoteSessionIssuerRequest$Outbound,
    CreateGlobalRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      createRemoteSessionIssuerForm:
        CreateRemoteSessionIssuerForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        createRemoteSessionIssuerForm: "CreateRemoteSessionIssuerForm",
      });
    }),
  );

export function createGlobalRemoteSessionIssuerRequestToJSON(
  createGlobalRemoteSessionIssuerRequest:
    CreateGlobalRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    CreateGlobalRemoteSessionIssuerRequest$outboundSchema.parse(
      createGlobalRemoteSessionIssuerRequest,
    ),
  );
}
